import { KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import FontSize from '@omni/kit/theming/FontSize';
import Spacing from '@omni/kit/theming/Spacing';
import React from 'react';
import { StyleSheet, View } from 'react-native';

type KitNotFoundProps = {
  backgroundColor?: string;
  titleColor?: string;
  messageColor?: string;
};

const KitNotFound = ({
  backgroundColor,
  titleColor,
  messageColor,
}: KitNotFoundProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: backgroundColor || Colors.N0,
        },
      ]}
    >
      <KitText
        extraBold
        color={titleColor || Colors.N900}
        fontSize={FontSize.xxl}
        lineHeight={30}
        fontWeight={900}
        style={styles.title}
      >
        {t('error:pageNotFound')}
      </KitText>
      <KitText
        center
        color={messageColor || Colors.N500}
        fontSize={FontSize.m}
        lineHeight={22}
      >
        {t('error:pageNotFoundMessage')}
      </KitText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: Spacing.xxxl,
  },
  title: {
    marginBottom: Spacing.s,
  },
});

export default KitNotFound;
